module.exports = __webpack_public_path__ + "img/ethereum-coin.89bcbf86.jpg";